/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForCostRecommendationAzure extends models.GovernanceConfigurationBaseForCostRecommendation {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForCostRecommendationAzure");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForCostRecommendationAzure.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForCostRecommendationAzure>): GovernanceConfigurationForCostRecommendationAzure {
        let obj = Object.assign(new GovernanceConfigurationForCostRecommendationAzure(), model);
        GovernanceConfigurationForCostRecommendationAzure.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForCostRecommendationAzure>): GovernanceConfigurationForCostRecommendationAzure {
        if (!model) return null;
        return GovernanceConfigurationForCostRecommendationAzure.newInstance(<GovernanceConfigurationForCostRecommendationAzure> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForCostRecommendationAzure) {
        if (!obj) return;

        models.GovernanceConfigurationForCostRecommendationAzure.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForCostRecommendationAzure): boolean {
        if (models.GovernanceConfigurationBaseForCostRecommendation.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForCostRecommendationAzure.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Whether Hybrid Benefits Enabled Or Not
     */
    hybrid_benefits_enabled: boolean;

}
